// src/router/router.jsx
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import { pagesRoute, posRoutes, publicRoutes } from "./router.link";

// MUST render <Outlet /> inside these
import PosLayout from "./posLayout";
import AuthPages from "./authPages";
import HeaderLayouts from "./headerLayout";

import { RequireAuth, PublicOnly, isAuthenticated } from "./authGuards";
import RequirePermRoute from "./RequirePermRoute";

// Use the same component your app uses for 404:
import Error404 from "../feature-module/pages/errorpages/error404";

const AllRoutes = () => {
  // keep this if your guards/layouts need it; not used here for filtering anymore
  useSelector((s) => s?.auth?.user?.permissions || []);

  return (
    <Routes>
      {/* Public auth pages (only for logged-out) */}
      <Route element={<PublicOnly />}>
        <Route element={<AuthPages />}>
          {pagesRoute.map((r, i) => (
            <Route key={`auth-${i}`} path={r.path} element={r.element} />
          ))}
        </Route>
      </Route>

      {/* Private app */}
      <Route element={<RequireAuth />}>
        {/* Main app area */}
        <Route element={<HeaderLayouts />}>
          {publicRoutes.map((r, i) => (
            <Route
              key={`pub-${i}`}
              path={r.path}
              element={
                <RequirePermRoute route={r}>{r.element}</RequirePermRoute>
              }
            />
          ))}
        </Route>

        {/* POS area */}
        <Route element={<PosLayout />}>
          {posRoutes.map((r, i) => (
            <Route
              key={`pos-${i}`}
              path={r.path}
              element={
                <RequirePermRoute route={r}>{r.element}</RequirePermRoute>
              }
            />
          ))}
        </Route>
      </Route>

      {/* Global 404 (accessible to everyone – prevents loops) */}
      <Route path="/error-404" element={<Error404 />} />

      {/* Root + fallback */}
      <Route
        path="/"
        element={
          <Navigate to={isAuthenticated() ? "/pos" : "/pos/signin"} replace />
        }
      />
      <Route path="*" element={<Navigate to="/error-404" replace />} />
    </Routes>
  );
};

export default AllRoutes;
